import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import { IS_BUNDLE_APP } from "../../app_constant";
import { COLORS, COLORS_DARK } from "../assets";

import { AuthContext } from "./AuthProvider";
import theme_config from "../../config";

export const ThemeContext = createContext();

export const ThemeProvider = (props) => {
  const { profile, bundleData } = useContext(AuthContext);
  const [currentTheme, setCurrentTheme] = useState("light");
  useEffect(() => { }, [localStorage.getItem("SAVED_BUNDLE_DETAILS")]);
  const currentThemeRef = useRef(null);
  currentThemeRef.current = currentTheme;

  // useEffect(() => {
  //   const theme = localStorage.getItem("Theme") || "light";
  //   const body = document.body;
  //   if (theme === "light") {
  //     setCurrentTheme("light");
  //     body.classList.remove("dark");
  //   } else if (theme === "dark") {
  //     setCurrentTheme("dark");
  //     body.classList.add("dark");
  //   }
  //   getTheme();
  // }, [currentTheme]);

  
  useEffect(() => {
    const fetchAndApplyTheme = async () => {
      const savedTheme = localStorage.getItem("Theme");
      let theme = savedTheme;

      if (!theme) {
        const defaultTheme = theme_config.default_theme_mode;
        theme = defaultTheme || "light";
        localStorage.setItem("Theme", theme);
      }

      const body = document.body;

      if (theme === "light") {
        setCurrentTheme("light");
        body.classList.remove("dark");
      } else if (theme === "dark") {
        setCurrentTheme("dark");
        body.classList.add("dark");
      }

      getTheme();

    
    };

    fetchAndApplyTheme();
  }, [currentTheme]);
  
  async function setAppTheme(mode) {
    setCurrentTheme(mode);
  }

  function getThemeName() {
    return currentTheme;
  }

  function getTheme() {
    if (currentTheme.includes("system")) {
      const systemTheme = "light";

      if (systemTheme == "light") {
        return COLORS;
      } else {
        return COLORS_DARK;
      }
    } else if (currentTheme == "light") {
      return COLORS;
    } else if (currentTheme == "dark") {
      return COLORS_DARK;
    }
  }

  useEffect(() => { }, [currentTheme]);

  const theme = getTheme();
  return (
    <ThemeContext.Provider
      value={{
        theme,
        currentTheme,
        setCurrentTheme,
        setAppTheme,
        getThemeName,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};
